import { StofInputProps } from "../../schemas/Stof/Stof.schema";
import { load } from "../home/Loads.model";

export class StofModel implements StofInputProps {
  page: number = 0;
  size: number = 5;
  country: string = "";
  stateId: string = "";
  carrierId: string = "";
  carrierScac: string = "";
  carrierTier: string = "";
  userRole: string = "";
  managedEquipmentCapability: string = "";
  nonManagedEquipmentCapability: string = "";
  sortColumn: string = "pickUpStartDate";
  sortDirection: string = "asc";

  getStateBasedLoad() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    const {similarLoads, ...updatedLoad} = load;
    return {
      query: {
        getStateBasedLoad: {
          __args: {
            input: input,
          },
          totalRecords: true,
          loadPostings: {
            ...updatedLoad,
            exclusiveLoad: true
          },
        },
      },
    };
  }
}
